var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7D96929Fc5288F473Df650Ae105C8804C46B57E2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 1440.5 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M0 86C0 94.8366 7.16344 102 16 102C24.8366 102 32 94.8366 32 86C32 77.1634 24.8366 70 16 70C7.16344 70 0 77.1634 0 86ZM16 0H13V86H16H19V0H16Z",
    fill: "url(#paint0_linear_2002_52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M282.5 86C282.5 94.8366 289.663 102 298.5 102C307.337 102 314.5 94.8366 314.5 86C314.5 77.1634 307.337 70 298.5 70C289.663 70 282.5 77.1634 282.5 86ZM298.5 0H295.5V86H298.5H301.5V0H298.5Z",
    fill: "url(#paint1_linear_2002_52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M564.5 86C564.5 94.8366 571.663 102 580.5 102C589.337 102 596.5 94.8366 596.5 86C596.5 77.1634 589.337 70 580.5 70C571.663 70 564.5 77.1634 564.5 86ZM580.5 0H577.5V86H580.5H583.5V0H580.5Z",
    fill: "url(#paint2_linear_2002_52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M845.5 86C845.5 94.8366 852.663 102 861.5 102C870.337 102 877.5 94.8366 877.5 86C877.5 77.1634 870.337 70 861.5 70C852.663 70 845.5 77.1634 845.5 86ZM861.5 0H858.5V86H861.5H864.5V0H861.5Z",
    fill: "url(#paint3_linear_2002_52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M1127.5 86C1127.5 94.8366 1134.66 102 1143.5 102C1152.34 102 1159.5 94.8366 1159.5 86C1159.5 77.1634 1152.34 70 1143.5 70C1134.66 70 1127.5 77.1634 1127.5 86ZM1143.5 0H1140.5V86H1143.5H1146.5V0H1143.5Z",
    fill: "url(#paint4_linear_2002_52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M1408.5 86C1408.5 94.8366 1415.66 102 1424.5 102C1433.34 102 1440.5 94.8366 1440.5 86C1440.5 77.1634 1433.34 70 1424.5 70C1415.66 70 1408.5 77.1634 1408.5 86ZM1424.5 0H1421.5V86H1424.5H1427.5V0H1424.5Z",
    fill: "url(#paint5_linear_2002_52)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2002_52",
    x1: 16.4999,
    y1: 0.000020362,
    x2: 16.4999,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C281",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2002_52",
    x1: 299,
    y1: 0.000020362,
    x2: 299,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C281",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2002_52",
    x1: 581,
    y1: 0.000020362,
    x2: 581,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C281",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2002_52",
    x1: 862,
    y1: 0.000020362,
    x2: 862,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C281",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2002_52",
    x1: 1144,
    y1: 0.000020362,
    x2: 1144,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C281",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2002_52",
    x1: 1425,
    y1: 0.000020362,
    x2: 1425,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C281",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7D96929Fc5288F473Df650Ae105C8804C46B57E2);
export default __webpack_public_path__ + "static/media/7d96929fc5288f473df650ae105c8804c46b57e2.4bcc5f0a14682dcc408616b553304f39.svg";
export { ForwardRef as ReactComponent };